// our service
const SERVICE = 'forge-ui';

// static values to pass to atl-attribution header taken from go/workday
const BUSINESS_UNIT = 'Ecosystem Engineering';
const COST_CENTER = '3039';
const TEAM = 'Eng - Ecosystem - Developer Platform - UI';

export const createAtlAttributionHeader = (workspaceAri?: string): string => {
	return JSON.stringify({
		atlWorkspaceAri: workspaceAri,
		service: SERVICE,
		businessUnit: BUSINESS_UNIT,
		costCenter: COST_CENTER,
		team: TEAM,
	});
};
